export default {
  //登录
  LOGIN: '/jcnapi/system/user/login',
  //退出
  LOGOUT: '/jcnapi/system/user/logout'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/user/index.js